// extracted by mini-css-extract-plugin
module.exports = {"DocumentCardTitleWrapper":"DocumentCard_DocumentCardTitleWrapper__FWhKd","DocumentCardDescriptionWrapper":"DocumentCard_DocumentCardDescriptionWrapper__224T5"};